import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CrashMessage } from '../../components/crash/CrashMessage';
import { CrashMessageContainer } from '../../components/crash/CrashMessageContainer';
import { CrashMessageHeader } from '../../components/crash/CrashMessageHeader';
import { CrashMessageFooter } from '../../components/crash/CrashMessageFooter';

export const MainContentCrash: FC = () => (
  <CrashMessageContainer>
    <CrashMessageHeader>
      <FormattedMessage id="app/common-app/MainContentCrash.tsx/1" />
    </CrashMessageHeader>
    <CrashMessage />
    <CrashMessageFooter />
  </CrashMessageContainer>
);
